module.exports = __webpack_public_path__ + "static/media/Fon_NTÜ_workshop_11128.aae66c71.pdf";